import React, { FC } from "react";
import DogCatImage from "./../../../../Static/Images/Dog_cat.png";
import {
  CompraSuccessContainer,
  CompraSucessTitle,
  DogCatContainer,
} from "./../../../../Pages/Checkout/Checkout.styles";
import { Header, Rodape } from "../../../../Components";
import { useHistory } from "react-router-dom";

const ConcluirContato: FC = () => {
  const history = useHistory();

  return (
    <>
      <Header
        showPlan={false}
        history={history}
        plano={undefined}
      />
      <CompraSuccessContainer>
        <CompraSucessTitle>Muito Obrigado!</CompraSucessTitle>
        <DogCatContainer src={DogCatImage} />
        <Rodape showNeedHelp={true} />
      </CompraSuccessContainer>
    </>
  );
};

export default ConcluirContato;